import * as Yup from 'yup';

import { ORIGIN_TAG_API } from '~support-at-home/lib/serviceOrigin';

import { Column } from '~components/table-view';
import ServiceSourceBadge from '~support-at-home/components/config/services/ServiceSourceBadge';

import { SahCategory, SahService } from '~lookups/models';

export { ORIGIN_TAG_API };
const isNotImported = (row: any) => row?.origin_tag !== ORIGIN_TAG_API;

const columnsFactory = (services: SahService[], category: SahCategory[]): Column[] => {
  const serviceOptions = services.map((service) => ({ id: service.id, name: service.name }));

  return [
    {
      // Display-only (dotted id), so it never reaches a create/update payload.
      id: 'display.source',
      header: 'Source',
      type: 'custom',
      component: ServiceSourceBadge,
      isEditable: false,
    },
    {
      id: 'service_id',
      header: 'Service Name',
      type: 'select',
      options: serviceOptions,
      isEditable: isNotImported,
      validation: Yup.mixed().required('Service is required'),
    },
    {
      // Display-only derived column. The dotted id keeps it out of create/update payloads
      // (filterRowFields skips dotted keys) and away from the real category_id row field.
      id: 'service.category_name',
      header: 'Category',
      type: 'text',
      isEditable: false,
      deriveValue: (row) => {
        const service = services.find((s) => s.id === row.service_id);
        return service ? (category.find((c) => c.id === service.category_id)?.name ?? '') : '';
      },
    },
    {
      // Display-only (dotted id). Blank for hand-entered rows.
      id: 'display.approval_type',
      header: 'Approval type',
      type: 'text',
      isEditable: false,
      deriveValue: (row) => row.classification_level_text ?? '',
    },
    {
      id: 'start_date',
      header: 'Start Date',
      type: 'date',
      isEditable: isNotImported,
      validation: Yup.string().required('Start date is required'),
    },
    {
      id: 'end_date',
      header: 'End Date',
      type: 'date',
      isEditable: isNotImported,
      validation: Yup.string()
        .required('End date is required')
        .test('end-after-start', 'End date must be after start date', function (value) {
          const { start_date } = this.parent;
          if (!value || !start_date) return true;
          return new Date(value) >= new Date(start_date);
        }),
    },
  ];
};

export default columnsFactory;
